import { Briefcase } from 'lucide-react';
import { VENDOR_PROFILE } from './vendor/mockVendorData';
import AssignedJobsLedger from './vendor/AssignedJobsLedger';
import FinancialsPanel from './vendor/FinancialsPanel';
import AvailabilityUpdater from './vendor/AvailabilityUpdater';

export default function VendorPortal() {
  return (
    <section aria-label="Vendor transporter portal" className="space-y-5">
      <div className="flex flex-wrap items-end justify-between gap-3 border-b border-logi-grid pb-4">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-indigo-500/10 ring-1 ring-indigo-500/30">
              <Briefcase className="h-4 w-4 text-indigo-400" strokeWidth={1.75} />
            </div>
            <span className="text-xs font-semibold uppercase tracking-widest text-indigo-400/80">
              OGTS LogiCore™ · Vendor Self-Service Portal
            </span>
          </div>
          <h2 className="text-xl font-bold tracking-tight text-logi-text sm:text-2xl">
            {VENDOR_PROFILE.companyName}
          </h2>
          <p className="mt-1 text-sm text-logi-muted">
            {VENDOR_PROFILE.vendorId} · Contract {VENDOR_PROFILE.contractRef} ·{' '}
            {VENDOR_PROFILE.activeJobs} active jobs
          </p>
        </div>
      </div>

      <AssignedJobsLedger />
      <FinancialsPanel />
      <AvailabilityUpdater />
    </section>
  );
}
